var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-text-input-mail"},[_c('input',{staticClass:"base-text-input-mail-class",attrs:{"type":"email","placeholder":"test@mail.com","maxlength":"254","name":"email"},domProps:{"value":_vm.value},on:{"input":_vm.inputText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }